import { FC, PropsWithChildren } from 'react';
import styles from './ApartmentCardWrapper.module.scss';

const ApartmentCardWrapper: FC<PropsWithChildren<{ isDisabled?: boolean }>> = ({ children, isDisabled }) => {
  return <div className={`${styles.wrapper} ${isDisabled ? styles.isDisabled : ''}`}>{children}</div>;
};

export default ApartmentCardWrapper;
